import React from 'react';
import { Button } from 'primereact/button';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { defaultKeys } from 'constants/automation';

export default function AddFilterActionBtn(props) {
  const { index, showAddFilter = true, showAddAction = true } = props;

  const { filterMethods, actionMethods } = useFormContext();

  const onAddFilter = () => {
    filterMethods.append({ label: '', value: '', condition: '' });
  };

  const onAddAction = () => {
    if (typeof index === 'number') {
      actionMethods.insert(index, { ...defaultKeys });
    } else {
      actionMethods.append({ action_code: '' });
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center gap-4 p-4">
      {showAddFilter && (
        <Button
          icon="pi pi-plus"
          label="Add Filter"
          style={{ width: '120px', justifyContent: 'center', height: '35px' }}
          onClick={onAddFilter}
          className="p-button-primary p-button-sm"
        />
      )}
      {showAddAction && (
        <Button
          icon="pi pi-plus"
          label="Add Action"
          style={{ width: '120px', justifyContent: 'center', height: '35px' }}
          onClick={onAddAction}
          className="p-button-primary p-button-sm"
        />
      )}
    </div>
  );
}

AddFilterActionBtn.propTypes = {
  index: PropTypes.number,
  showAddFilter: PropTypes.bool,
  showAddAction: PropTypes.bool,
};
